<template>
    <div class="page">
        <div class="content">
            <p class="tit f-fwb">报障单编号<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.orderNo" type="text" placeholder="请输入报障单编号" />
                <van-button class="cx" type="primary" @click="getData">查询</van-button>
            </div>
            <p class="tit f-fwb">用户名称<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.userName" type="text" placeholder="请输入用户名称" />
            </div>
            <p class="tit f-fwb">设备名称<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.deviceName" type="text" placeholder="请输入设备名称" />
            </div>
            <p class="tit f-fwb">故障主诉<span class="f-fc4">*</span></p>
            <div class="inp inp2 mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.fault" type="textarea" placeholder="请输入内容" />
            </div>
            <p class="tit f-fwb">现场解决措施<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.solutions" type="text" placeholder="请输入内容" />
            </div>
            <p class="tit f-fwb">跟进技术<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.technician" type="text" placeholder="请输入内容" />
            </div>
            <p class="tit f-fwb">上门时间<span class="f-fc4">*</span></p>
            <div class="inp inp3 mt-25" data-flex="cross:center" @click="dateShow = true">
                <p data-flex-box="1" class="f-fs14 f-fc1" v-if="!isEmpty(formData.doorTime)">{{ formData.doorTime }}</p>
                <p data-flex-box="1" class="f-fs14" v-else>请选择上门时间</p>
                <img src="../../assets/images/left.png" alt="">
            </div>
            <van-overlay :show="dateShow" @click="dateShow = false">
                <div class="wrapper" @click.stop>
                    <van-datetime-picker class="date" v-model="currentDate" type="datehour" title="选择年月日小时"
                        :min-date="minDate" :max-date="maxDate" @confirm="confirmDate" @cancel="dateShow = false" />
                </div>
            </van-overlay>

            <p class="tit f-fwb">用户联系电话<span class="f-fc4">*</span></p>
            <div class="inp mt-25" data-flex="cross:center">
                <van-field class="f-fs14" v-model="formData.userPhone" type="tel" placeholder="请输入手机号" />
            </div>
        </div>
        <div class="btn">
            <van-button type="primary" @click="submit">立即提交</van-button>
        </div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field, DatetimePicker, Overlay, Toast } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import { datetimeFormat } from '../../utils/datetime'

export default {
    mixins: [mix1],
    components: {
        MgPopup, Button, NumberKeyboard,
        [Overlay.name]: Overlay,
        [Field.name]: Field,
        [DatetimePicker.name]: DatetimePicker,
        [Button.name]: Button,
    },
    data() {
        // const currentDate = ref(new Date());
        return {
            currentDate: new Date(),
            minDate: new Date(2022, 0, 1),
            maxDate: new Date(2030, 10, 1),
            dateShow: false,
            isCountdowning: false,
            btn1Text: '获取',
            tel: '',
            formData: {
                orderNo: '',
                deviceName: '',
                userName: '',
                solutions: "",
                fault: '',
                technician: '',
                doorTime: '',
                userPhone: '',

            }
        }
    },
    methods: {
        confirmDate(e) {
            this.dateShow = false
            this.formData.doorTime = datetimeFormat(e)
        },
        async getData() {
            let orderNos = this.formData.orderNo
            if (this.isEmpty(orderNos)) {
                Toast('请填写报障单编号');
                return
            }
            const promise = this.apiGet('order.info', { orderNo: orderNos })
            uiShowLoading()
            await delayAsync(500)
            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            if (this.isEmpty(apiResult.obj)) {
                uiAlert('暂无信息')
                return
            }

            let {
                orderNo,
                deviceName,
                userName,
                solutions,
                fault,
                technician,
                doorTime,
                userPhone,
            } = apiResult.obj
            this.formData = {
                orderNo,
                deviceName,
                userName,
                solutions,
                fault,
                technician,
                doorTime,
                userPhone,
            }
            // uiAlert('h成功', () => this.$router.go(-1))
        },
        async submit() {
            let formData = this.formData
            const promise = this.apiPost('orders.add', formData)
            if (this.isEmpty(formData.orderNo)) {
                Toast('请填写报障单编号');
                return
            }
            if (this.isEmpty(formData.deviceName)) {
                Toast('请填写设备名称');
                return
            }
            if (this.isEmpty(formData.userName)) {
                Toast('请填写用户名称');
                return
            }
            if (this.isEmpty(formData.solutions)) {
                Toast('请填写现场解决措施');
                return
            }
            if (this.isEmpty(formData.fault)) {
                Toast('请填写故障主诉');
                return
            }
            if (this.isEmpty(formData.technician)) {
                Toast('请填写跟进技术');
                return
            }
            if (this.isEmpty(formData.doorTime)) {
                Toast('请x选择上门时间');
                return
            }

            if (this.isEmpty(formData.userPhone)) {
                Toast('请填写用户联系电话');
                return
            }
            uiShowLoading()
            await delayAsync(500)
            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }

            uiAlert('提交成功', () => this.$router.go(-1))
        },

    },
    mounted() {

    },
    created() {
        let query = this.$route.query
    }
}
</script>

<style lang="less" scoped>
.content {
    // height: calc(100vh - 20px);
    padding: 24px;
    box-sizing: border-box;
    background: #fff;
    margin-top: 20px;

    .cx {
        background: #205CFF;
        border-color: #205CFF;
        width: 150px;
        height: 50px;
        margin-right: 5px;
    }

    .tit {
        font-size: 14px;
    }

    .inp {
        border-bottom: solid 1px #B9B9B9;
        width: 100%;
        margin: 0 auto;
        border-radius: 10px;
        margin-bottom: 40px;

        .van-cell {
            padding: 0 0 10px 0;
        }

        .van-cell::after {
            border: none;
        }

        p {
            font-size: 12px;
            color: #609FFA;
            width: 170px;
            padding-right: 20px;
            text-align: right;
        }
    }

    .inp2 {
        border: solid 1px #B9B9B9;

        .van-cell {
            padding: 10px 10px;
            box-sizing: border-box;
        }
    }

    .inp3 {
        padding: 18px 10px;
        box-sizing: border-box;
        border: solid 1px #B9B9B9;

        p {
            color: #b1b1b1;
            text-align: left;
        }

        img {
            width: 15px;
            height: 24px;
        }
    }


    .wrapper {
        position: none;

        .date {
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
        }
    }
}

.btn {
    padding-bottom: 30px;
    text-align: center;
    margin-top: 65px;

    button {

        width: 690px;
        height: 80px;
        border-radius: 200px;
        background: #205CFF;
        border-color: #205CFF;
        margin: 0 auto;
    }
}
</style>